import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('old.components.ConfirmationDropdown', {
    yesButtonText: 'yes',
    noButtonText: 'no',
});
